import { type ReactNode } from "react";
import { useSelector } from "react-redux";

import { type RootState } from "../../store";
import useRestaurantDetailsSync from "./hooks/useRestaurantDetailsSync";
import useAppLayoutRealtime from "./hooks/useAppLayoutRealtime";
import AppLayoutFrame from "./ui/AppLayoutFrame";
import OrderNotificationStack from "./ui/OrderNotificationStack";

const AppLayout = ({ children }: { children?: ReactNode }) => {
    const isMobileView = useSelector((state: RootState) => state.appGeneral.isMobileView);
    const showOpenPaymentsModal = useSelector((state: RootState) => state.paymentManagement.showOpenPaymentsModal);

    useRestaurantDetailsSync();

    const {
        closeOrderNotificationModal,
        getOrderCreatedAtMs,
        getOrderTrackingKey,
        openOrderNotificationModals,
    } = useAppLayoutRealtime();

    return (
        <AppLayoutFrame
            isMobileView={isMobileView}
            showOpenPaymentsModal={showOpenPaymentsModal}
            overlays={(
                <OrderNotificationStack
                    closeOrderNotificationModal={closeOrderNotificationModal}
                    getOrderCreatedAtMs={getOrderCreatedAtMs}
                    getOrderTrackingKey={getOrderTrackingKey}
                    openOrderNotificationModals={openOrderNotificationModals}
                />
            )}
        >
            {children}
        </AppLayoutFrame>
    );
};

export default AppLayout;
